import React, { useEffect, useState } from "react"
import SideMenu from "./sidemenu.jsx";
//import { Link } from "react-router-dom";
import ClaimsIntimation from "./claimsIntimation";
import UserManagment from "./usermanagment";
import RoleMaster from "./roleMaster";
import ClaimDetail from './claimDetail.jsx';
import ClaimData from "./claimData"
import UpdateRole from "./updateRole";
import { editModeOn, encryptValue, getFromDecreaptLocalStorage, saveInLocalStorage, viewModeOn } from "../utilFunctions";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import ClaimProcessing from "./claimProcessing";
import { WRAPPER_SERVICE, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import Profile from "./profile.jsx";
import VendorMasterCreation from "./vendorMaster/vendorMasterCreation.jsx";
import SurveyorMasterCreation from "./surveyorMaster/surveyorMasterCreation.jsx";
import ClaimBulkProcess from "./claimBulkProcess.jsx";
import Utrupload from "./UTRUpload.jsx";
import LoadingPage from "../reusableComponents/loader/loadingPage.jsx";
import Vendormaster from "./vendorMaster/Vendormaster.jsx";
import SurveyorMaster from "./surveyorMaster/SurveyorMaster.jsx";
import IndemnityMaster from "./IndemnityMaster.jsx";
import LossReserveMaster from "./LossReserveMaster.jsx"
import ClaimHandler from "./claimHandler.jsx";
import CompensationMaster from "./compensationMasters.jsx";
import ExcessMasters from "./excessMasters.jsx";
import { axiosRequest } from "../service.js";
import AnimalAttackMaster from "./AnimalAttackMaster.jsx";
import BulkSurveyAssignment from "./bulkSurvey/bulkSurveyAssignment.jsx";
import { healthProducts, HEALTH_PRODUCTS, modes, PAGE_NAME_KEYS } from "../consts.js";
import Forbidden from "../reusableComponents/Forbidden.jsx";
import { getUserFunctionalities } from "./apiHelper.js";
import { useMsal } from "@azure/msal-react";
import SawDetails from "./saw/SawDetails.jsx";
import ListPage from "./surveyManagement/ListPage.jsx"
import SearchPage from "./Health/ClaimIntimation/Search/SearchPage.jsx";
import HealthClaimProcessing from "./Health/ClaimProcessing/Page/HealthClaimProcessing.jsx";
import MyWorkItems from "./MyWorkItems/MyWorkItems.jsx";
// import ExcessMaster from "./excessMaster";

const DashboardMenu = (props) => {
  const navigate = useNavigate();
  const roleDataCookie = getFromDecreaptLocalStorage("roleData");
  const [productNames, setProductNames] = useState([]);
  const [showApplication, setShowApplication] = useState(false);
  const [fetchedRoleData, setFetchedRoleData] = useState(false);
  const [reRender, setReRender]= useState(false)
    const { instance } = useMsal();
  const getProductName = async () => {
    try {
      const { data } = await axiosRequest().get(`${WRAPPER_SERVICE}/product-details`);
      const sortedProductNames = data.products
        .filter(product => product.productId !== 6 && !HEALTH_PRODUCTS.includes(product.productId))
        .sort((a, b) => a.productName.localeCompare(b.productName))
        .map(product => ({ label: product.productName, value: product.productId }));
      setProductNames(sortedProductNames);
    } catch (error) {
    }
  };

  const getLoginUserDetails = async (roleID, fromUpdate, shouldNavigate = true) => {
    if (roleID) {
      try {
        const { data } = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/role/${roleID}`);
        if (fromUpdate == null || fromUpdate.employeeID === roleDataCookie?.employeeID) {
          const loginUserDetailEncripted = encryptValue(JSON.stringify(data));
          saveInLocalStorage("loginUserDetail", loginUserDetailEncripted);
        }
        if ((fromUpdate && data.roleName !== "Admin" && fromUpdate.employeeID === roleDataCookie?.employeeID) && shouldNavigate) {
          navigate('/dashboard/claim-intimation');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    getProductName();
    if (!Cookies.get("token")) {
      navigate('/');
    } else {
      setShowApplication(true);
    }
  }, []);

  useEffect(() => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/status`)
      .then(data => {
        const statusListEncripted = encryptValue(JSON.stringify(data.data));
        getLoginUserDetails(roleDataCookie?.userRoleMapping?.roleID);
        saveInLocalStorage("CMSstatusList", statusListEncripted);
      })
      .catch(console.error);
      if(roleDataCookie && roleDataCookie.emailID) {
        getUserFunctionalities(roleDataCookie.emailID, setFetchedRoleData, instance)
      }
  }, []);

  const renderPageContent = () => {
    const { page, functionality, mode = modes.VIEW_MODE } = props;

    const pageComponents = {
      [PAGE_NAME_KEYS.CLAIM_INTIMATION]: <ClaimsIntimation roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.HEALTH_CLAIM_INTIMATION]: <SearchPage roleDataCookie={roleDataCookie} productNames={healthProducts} />,
      [PAGE_NAME_KEYS.MY_WORK_ITEMS]: <MyWorkItems roleDataCookie={roleDataCookie} productNames={productNames}/>,
      [PAGE_NAME_KEYS.CLAIM_BULK_PROCESS]: <ClaimBulkProcess roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.USER_MANAGEMENT]: <UserManagment getLoginUserDetails={getLoginUserDetails} roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.BULK_SURVEY]: <BulkSurveyAssignment roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.ROLE_MASTER]: <RoleMaster page={page} roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.VENDOR_MASTER]: <Vendormaster page={page} roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.VENDOR_MASTER_CREATION]: <VendorMasterCreation roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.SURVEYOR_MASTER]: <SurveyorMaster page={page} roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.SURVEYOR_MASTER_CREATION]: <SurveyorMasterCreation page={page} roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.CLAIM_PROCESSING]: <ClaimProcessing page={page} productNames={productNames} />,
      [PAGE_NAME_KEYS.HEALTH_CLAIM_PROCESSING]: <HealthClaimProcessing page={page} productNames={healthProducts} />,
      [PAGE_NAME_KEYS.UTR_UPLOAD]: <Utrupload productNames={productNames} roleDataCookie={roleDataCookie} />,
      [PAGE_NAME_KEYS.INDEMNITY_MASTER]: <IndemnityMaster roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.CLAIM_HANDLER]: <ClaimHandler productNames={productNames} />,
      [PAGE_NAME_KEYS.HEALTH_CLAIM_HANDLER]: <ClaimHandler productNames={healthProducts} />,
      [PAGE_NAME_KEYS.COMPENSATION_MASTER]: <CompensationMaster roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.EXCESS_MASTER]: <ExcessMasters roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.LOSS_RESERVE_MASTER]: <LossReserveMaster roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.ANIMAL_ATTACK]: <AnimalAttackMaster roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.SAW]: <SawDetails roleDataCookie={roleDataCookie} productNames={productNames} />,
      [PAGE_NAME_KEYS.SURVEY_MANAGEMENT]: <ListPage  productNames={productNames}/>,
    };

    
  if (mode === modes.EDIT_MODE ? editModeOn(functionality): viewModeOn(functionality)) {
    return pageComponents[page] || <ClaimDetail page={page} productNames={productNames} />;
  } else {
    return <Forbidden/>
  };
}

  return (
    <div>
      <div className="row flex-nowrap">
        {showApplication && fetchedRoleData ? (
          <>
            <SideMenu page={props.page} roleDataCookie={roleDataCookie} reRender={reRender}/>
            <div className="col py-3" style={{ maxHeight: "100vh", overflow: "auto" }} id={"scrollable-container"}>
              <Profile roleDataCookie={roleDataCookie} setReRender={setReRender}/>
              {renderPageContent()}
            </div>
          </>
        ) : <LoadingPage />}
      </div>
    </div>
  );
};

export default DashboardMenu;
